export function modifyDT(objectsArray: any, key: string) {
  const modifiedArray = objectsArray.map((obj: any) => {
    if (obj[key]) {
      obj[key] = obj[key].replace('T', ' ').replace(/\.\d+/, '')
    }
    return obj
  })
  return modifiedArray
}
